var geocoder, map, placeSearch, autocomplete, marker;
var googleApiLoaded = false;
var key = 'AIzaSyBhqD5BcsPIUmky6_n7ZjoeiwB3mEGLqiY';
var GOOGLE_MAP_CLASS = '.sk-attr--map';

const options = {
    types: ['establishment'], //geocode
    componentRestrictions: { country: "AE" },
}

var input;

function startGoogleMessage() {
    input = document.querySelector("#Home-capturedData-PolicyHolder-Address");
    var mapAttribute = document.querySelector(GOOGLE_MAP_CLASS);
    
    if (input !== null && mapAttribute !== null) {
        loadGoogleMapsAPI();
    }
}

function loadGoogleMapsAPI() {
    if (!googleApiLoaded) {
        var imported = document.createElement('script');
        imported.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&callback=initGoogleFeatures&libraries=places';
        document.head.appendChild(imported);
        googleApiLoaded = true;
    } else {
        initGoogleFeatures();
    }
}
   
function initGoogleFeatures() {
    var mapAttribute = document.querySelector(GOOGLE_MAP_CLASS);
    initMap(mapAttribute, input);
    initGoogleAddressSearch();
}

function initMap(mapAttribute, addressInput) {
    geocoder = new google.maps.Geocoder();

    var mapOptions = {
        zoom: 14,
        center: { lat: 25.0437937, lng: 55.213771 }
    };

    map = new google.maps.Map(mapAttribute, mapOptions);
    setAddressOnMap(addressInput);
}

function setAddressOnMap(addressInput) {
    // var address = addressInput.formatted_address ? addressInput.formatted_address : addressInput.value;
    var address = addressInput.plus_code ? addressInput.plus_code.compound_code : addressInput.formatted_address ? addressInput.formatted_address : addressInput.value;

    if (address && address !== "") {
        geocoder.geocode({'address': address}, function (results, status) {
            if (status == 'OK') {
                map.setCenter(results[0].geometry.location);
                removeMarker();
                marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });
    }
}

function removeMarker() {
    if (marker) {
        marker.setMap(null);
    }
}

function initGoogleAddressSearch() {
    autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();
    const addressInput = document.querySelector("#Home-capturedData-PolicyHolder-Address");
    address = addressInput.value;
    setAddressOnMap(place);
}

export { startGoogleMessage };